import { Typography } from '@mui/material';

interface ListaVaziaProps {
    text?: string;
    children?: React.ReactNode;
}
export default function ListaVazia({ text, children }: ListaVaziaProps) {

    return (
        <div style={{ marginTop: 50, marginBottom: 10, display: 'flex', flexDirection: 'column', alignItems:'center' }}>
            <Typography style={{ fontWeight: 'bold' }} >
                {
                    text
                        ? text
                        : 'A lista está vazia'
                }
            </Typography>
            {children && children}
        </div>
    )
}
